import { pathOr } from 'ramda';
import { mapGetters } from 'vuex';

import { formatProductSize } from '@/utils/common';
import {
  isProductPackSerum,
  getProductPackSize,
  getProductPackName,
  getProductPackUsage
} from '@/models/core/ProductPack';
import { getSizeValue, getSizeUnits } from '@/models/core/values';

import { SIZE_MEASUREMENT_UNIT_KEY } from '@/constants/treatment';
import { PRODUCTS_CONFIGURATION } from '@/constants/your-routine';
import { types } from '@/store/types';

const productConfigMixin = {
  computed: {
    ...mapGetters({
      productConfigMixin__getIsProductRecommended: types.getters.GET_IS_PRODUCT_RECOMMENDED
    })
  },
  methods: {
    getProductImage({ product, hasProductSizeOptions }) {
      const name = getProductPackName(product);
      const isSerumProduct = isProductPackSerum(product);
      const size = getProductPackSize(product);

      if (isSerumProduct) {
        const usage = getProductPackUsage(product);

        return `${name}-${usage}`;
      }

      if (hasProductSizeOptions) {
        return `${name}-${getSizeValue(size)}`;
      }

      return name;
    },
    getProductConfiguration(product) {
      const productName = getProductPackName(product);

      return PRODUCTS_CONFIGURATION[productName] || {};
    },
    getProductDescription({ product }) {
      const { subtitle, subtitleRecommended } = this.getProductConfiguration(product);
      const isRecommended = this.productConfigMixin__getIsProductRecommended(product);

      const subtitleConfig = isRecommended && subtitleRecommended ? subtitleRecommended : subtitle;

      const usage = getProductPackUsage(product);

      return pathOr(subtitleConfig, [usage], subtitleConfig);
    },
    getProductSizeOptions(productOptions) {
      const sizeOptions = productOptions.map(getProductPackSize);

      return sizeOptions.map(sizeOption => {
        const value = getSizeValue(sizeOption);
        const units = getSizeUnits(sizeOption);
        const unitsTranslated = this.$t(SIZE_MEASUREMENT_UNIT_KEY[units]);
        const sizeOptionLabel = formatProductSize({ value, units: unitsTranslated });

        return {
          value,
          units,
          sizeOptionLabel
        };
      });
    }
  }
};

export { productConfigMixin };
